import { useSyncExternalStore } from 'react';
import {
  SuspensionState,
  accountSuspensionState,
  subscribeToAccountSuspension,
} from '@/lib/accountSuspension';

const SERVER_SNAPSHOT: SuspensionState = { suspended: false, reason: null };

/**
 * Whether the account is locked out for non-payment, and why.
 *
 * Backed by the module store in `lib/accountSuspension` rather than a context,
 * because the axios interceptor that flips it is installed at module scope,
 * before any provider exists.
 */
export function useAccountSuspension(): SuspensionState {
  return useSyncExternalStore(
    subscribeToAccountSuspension,
    accountSuspensionState,
    () => SERVER_SNAPSHOT,
  );
}
